import React, {useEffect, useRef, useState} from "react";
import {routes} from "../../../../../../../core/models/static/routes/app-routes";
import {Row} from "reactstrap";
import {ArrowBack} from "@mui/icons-material";
import IconButton from "../../../../../../components/base/button/icon_button";
import ObserversService from "../../../../../../../core/services/observers";
import useIsMounted from "../../../../../../hooks/use-is-mounted";
import {useConfigureNotebook} from "../../../../../../hooks/use-notebook-config";
import {Link, useHistory, useLocation, useParams} from "react-router-dom";
import useBehavioralAnalyticsTool from "../../../../../../hooks/use-behavioural-analytics-tool";

const SurveySingleView = () => {
    const history = useHistory()
    const params = useParams()
    const location = useLocation();
    const [survey, setSurvey] = useState(null);
    /** @type {React.MutableRefObject<HTMLDivElement>}*/
    const containerRef = useRef();
    const initialRef = useRef(true);
    const isMounted = useIsMounted();
    const {configureNotebookTags} = useConfigureNotebook('surveys-list-view');
    const {configureBehavioralTool} = useBehavioralAnalyticsTool();

    /**
     * As soon as the component is mounted:
     * - Configures the notebook tags for the view
     * - Configures the behavioral analytics tool for the view
     */
    useEffect(() => {
        configureNotebookTags((noteTags) => noteTags.surveyPreview(params?.surveyId));
    }, [configureNotebookTags, params?.surveyId]);

    /**
     * With initial render and each change in the url params:
     * - Checks if the selected survey exists in location state and its id is same as url param
     * - Adds a resize observer using the polyfill for this action to the survey container
     * - if it's not, navigates user back to
     * - also hides the floating action button when in this screen
     */
    useEffect(() => {
        const selectedSurvey = location.state;
        const floatyActionButton = document.querySelector('.app-floaty-component');
        if (floatyActionButton)
            floatyActionButton.style.visibility = 'hidden';
        if (!!Object.keys(selectedSurvey ?? {}).length) {
            if ((params?.surveyId ?? 0) === (selectedSurvey?.id?.toString() ?? -1)) {
                setSurvey(selectedSurvey);
                if (!containerRef?.current)
                    return;
                const observer = ObserversService.newResizeObserver(onSurveyContainerSizeChanged);
                ObserversService.observeResizeObserver(observer, containerRef.current);
                return () => {
                    ObserversService.disconnectResizeObserver(observer);
                    floatyActionButton.style.visibility = 'unset'
                };
            }
        } else {
            history.replace(routes.userPlatform.surveys.list);
        }
        return () => {
            floatyActionButton.style.visibility = 'unset'
        }

    }, [params])

    /**
     * Checks if the survey container has been resized only one,
     * based on that, changes the height of the Iframe to remove the scrollbar
     */
    const onSurveyContainerSizeChanged = () => {
        if (!initialRef.current)
            return;
        initialRef.current = false;
        const iframe = containerRef.current?.querySelector('iframe');
        if (!iframe)
            return;
        const height = containerRef.current.clientHeight;
        if (!isMounted())
            return;
        iframe.setAttribute('height', +height + 250);
    }


    return (
        <>
            <Row className='no-gutters w-100 align-items-start justify-content-center survey-single-view'>
                <div
                    className={'d-flex flex-row justify-content-between align-items-center w-100 mt-4 mb-4 px-3 page-title-section'}>
                    <div className={'title-section'}>
                        <IconButton
                            color={'paper.secondary'}
                            component={Link}
                            to={routes.userPlatform.surveys.list}
                            replace
                        >
                            <ArrowBack className='icon normal'/>
                        </IconButton>
                        <div className={'title-texts'}>
                            <p>
                                Survey Preview
                            </p>
                            <p>
                                {survey?.title ?? ''}
                            </p>
                        </div>
                    </div>
                </div>
                <div ref={containerRef} className={'survey-iframe-container'}
                     dangerouslySetInnerHTML={{__html: survey?.link ?? "<p />"}}/>
            </Row>
        </>
    );
}

export default SurveySingleView;
